import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/status-codes')({
  component: StatusCodesLayout,
});

/**
 * Layout route for /status-codes — renders child routes via Outlet.
 * The actual list page lives at status-codes/index.tsx, and the
 * add form at status-codes/add.tsx.
 */
function StatusCodesLayout() {
  return <Outlet />;
}
